import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./HistoryDetailComponent.css";
import { useNavigate } from "react-router-dom";

import tgIcon from "../../../img/tg.png"; // Corrected path
import copyIcon from "../../../img/copy.png"; // Corrected path

const HistoryDetailComponent = ({ socket }) => {
  const navigate = useNavigate();

  const { id } = useParams(); // Extract the 'id' from the URL
  const [username, setUsername] = useState("Loading"); // Состояние для хранения username
  const [balance, setBalance] = useState("Loading"); // Состояние для хранения balance
  const [address, setAddress] = useState("Loading"); // Состояние для хранения address
  const [defaultaddress, setDefaultAddress] = useState("Loading"); // Состояние для хранения address

  const defaultText = 'Copy past';
  const successText = 'Past copied'

  const [buttonCopy, setButtonCopy] = useState(defaultText);

  useEffect(() => {
    if (socket) {
      // Отправляем запрос на сервер для получения данных
      socket.emit("get_history_detail", { id }, (response) => {
        if (response.success) {
          const { username, balance, address } = response.data;
          setUsername(username); // Устанавливаем username
          setBalance(balance); // Устанавливаем balance
          setDefaultAddress(address);
          setAddress(shortenAddress(address));
        } else {
          console.error("Failed to fetch history detail:", response.message);
        }
      });
    }
  }, [socket, id]);

  const shortenAddress = (address) => {
    if (!address || address.length < 4) return address; // Если адрес слишком короткий, возвращаем его без изменений
    return `${address.slice(0, 2)}...${address.slice(-2)}`;
  };

  const redirectLink = (username) => {
    const resultUsername = username.split("@");
/*     const resultUsername = username.split("@");
    const telegramUrl = `tg://resolve?domain=${resultUsername[1]}`;
    window.location.href = telegramUrl; */

    const tele = window.Telegram.WebApp;
    tele.openTelegramLink(`https://t.me/${resultUsername[1]}`);
  };

  const copyPaste = async () => {
    try {
      // Отправляем запрос на сервер для получения pasteUsername
      const response = await new Promise((resolve) => {
        socket.emit("get_paste_username", (data) => resolve(data));
      });

      if (!response.success) {
        console.error("Failed to fetch pasteUsername:", response.message);
        return;
      }

      const pasteUsername = response.data;

      // Заменяем плейсхолдер {{nft}} на текущий username
      const formattedText = pasteUsername.replace("{{nft}}", username);

      // Копируем текст в буфер обмена
      navigator.clipboard.writeText(formattedText).then(() => {
        setButtonCopy(successText);

        // Возвращаем текст к исходному значению через 3 секунды
        setTimeout(() => {
          setButtonCopy(defaultText);
        }, 3000); // 3000 мс = 3 секунды
      });
    } catch (error) {
      console.error("Error during copyPaste:", error.message);
    }
  };

  const copyText = async (text) => {
    try {
      navigator.clipboard.writeText(text).then(() => {

      });
    } catch (error) {
      console.error("Error during copyPaste:", error.message);
    }
  };

  return (
    <div className="mainContainer">
      <div className="wrapper">
        <div className="mainHistoryContainer">
          <span className="title">PARSER</span>
          <div className="historyDetailContainer">
            <div className="titleDetailContainer">
              <span className="titleDetail" onClick={() => copyText(defaultaddress)}>{address}</span>{" "}
              {/* Отображаем ID */}
              <span className="titleDetail">{balance} TON</span>{" "}
              {/* Отображаем баланс */}
            </div>
            <div className="mainInfoContainer">
              <span onClick={() => copyText(username)}>{username}</span> {/* Отображаем username */}
              <div className="buttonNavigation">
                <div className="buttonContainer">
                  <button className="redirectButton" onClick={() => redirectLink(username)}>
                    <img src={tgIcon} alt="Telegram" className="buttonIcon" />
                    Redirect
                  </button>
                </div>
                <div className="buttonContainers">
                  <button className="copyPastButton" onClick={copyPaste}>
                    {buttonCopy}
                    <img src={copyIcon} alt="Copy" className="buttonIcon" />
                  </button>
                </div>
              </div>
            </div>
            <div className="foundContainer">
              <button
                className="buttonOtpInActive"
                onClick={() => navigate("/history")}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryDetailComponent;